import { lazy } from 'react';

export const PlayerMarketingSmsForm = lazy(
  () => import('./PlayerMarketingSmsForm'),
);
